<template>
  <div></div>
</template>
<script>
export default {
  data: () => ({
    params: {}
  }),
  async mounted() {
    await this.$liff.init({ liffId: this.params.liffId });
  },
  created() {
    //https://love56-web.tunnel.schainbcs.io/liff/init?liff.state=%2Fliff%2FselectPetReport%2Fladyicats%3FliffId%3D1491223853-5mELMvJE%26botId%3D%40gnx4787y%26action%3DgetReport%26t%3D653

    //parse url parameter
    const url = new URL(window.location.href);
    let liffState;
    for (let [key, value] of url.searchParams.entries()) {
      if (key === "liff.state") {
        liffState = value;
      }
    }
    let thisVm = this;
    let array;
    liffState = liffState.replace(/^.*[?]/g, "");
    liffState.split("&").forEach(pair => {
      array = pair.split("=");
      thisVm.params[array[0]] = array[1];
    });
    console.log("params:" + JSON.stringify(thisVm.params));

    if (!this.params.liffId) {
      alert("liffId undefined");
    }

    if (!this.params.botId) {
      alert("botId undefined");
    }
  }
};
</script>